export default "{\n    \"label\": \"{{name}}\",\n    \"label_0\": \"Estado\",\n    \"label_plural\": \"{{count}} estados\"\n}\n"